/**
 * FN-FIX-C3 — Beállítások index oldal
 */
import { useAuth } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { PageHeader, Card } from '../../components/ui';

const SECTIONS = [
  { title: 'Cég-profil', desc: 'Cégnév, adószám, bankszámla, cím', href: '/beallitasok/ceg', icon: '🏢' },
  { title: 'NAV-kapcsolat', desc: 'NAV Online Számla credentials beállítása', href: '/beallitasok/nav', icon: '📡' },
  { title: 'Előfizetés', desc: 'Csomag, modulok, fizetési mód', href: '/beallitasok/szamlazas', icon: '💳' },
  { title: 'Felhasználók', desc: 'Csapattagok, szerepek, meghívások', href: '/beallitasok/felhasznalok', icon: '👥' },
  { title: 'Értesítések', desc: 'App, email és push csatornák típusonként', href: '/beallitasok/ertesitesek', icon: '🔔' },
  { title: 'Audit-napló', desc: 'Üzleti és technikai naplók, 8 éves megőrzés', href: '/beallitasok/audit', icon: '📋' },
];

export default function SettingsPage() {
  const { user } = useAuth();

  return (
    <div>
      <PageHeader title="Beállítások" description="Fiók, cég, számlázás és rendszer-beállítások" />

      {/* User info card */}
      <Card className="mb-4">
        <div className="card-h"><h3>Fiók</h3></div>
        <div className="row-li"><div className="ri-main"><div className="ri-t">Név</div><div className="ri-s">{user?.name}</div></div></div>
        <div className="row-li"><div className="ri-main"><div className="ri-t">E-mail</div><div className="ri-s">{user?.email}</div></div></div>
      </Card>

      {/* Settings grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '14px' }}>
        {SECTIONS.map(s => (
          <Link key={s.title} to={s.href} style={{ textDecoration: 'none', color: 'inherit' }}>
            <Card className="h-full" style={{ cursor: 'pointer', transition: 'box-shadow .15s' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', padding: '4px' }}>
                <div style={{ fontSize: '24px', flexShrink: 0, marginTop: '2px' }}>{s.icon}</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '14px', color: 'var(--navy)', marginBottom: '4px' }}>{s.title}</div>
                  <div style={{ fontSize: '12.5px', color: 'var(--slate)', lineHeight: 1.5 }}>{s.desc}</div>
                </div>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
